import {Component, OnInit, Injector} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {ModalBaseComponent} from '../modal-base-component';

@Component({
  selector: 'app-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.css']
})
export class InfoModalComponent extends ModalBaseComponent {

  information = '';

  constructor(private inject: Injector, private _bsModalRef: BsModalRef) {
    super(inject);
  }

  public closeModal(): void {
    this._bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/info-modal/info-modal.component.ts